/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type RentApiResourceType = typeof RentApiResourceType[keyof typeof RentApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RentApiResourceType = {
  rent: 'rent',
  booking_income: 'booking_income',
  booking_reconciliation: 'booking_reconciliation',
} as const;
